import * as React from 'react'
import { useCallback } from 'react'

import { useAppSelector } from '@user/store/hooks'
import { selectSalesFunnelById } from '@user/store/salesFunnel/slice'

import { getStyles } from './styling'
import { MissingRequirementDetails } from './MissingRequirementDetails'
import { selectOppCloseWinErrorsById } from '@user/store/opportunity'
import {
  closeDialogActionCreator as closeDialog,
  useCWQDialogContext,
} from '@user/components/SoldServices'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

interface Props {
  opportunityId: number
  salesFunnelId: string | number
}

export function CloseWonErrorDialog(props: Props) {
  const { salesFunnelId, opportunityId } = props

  const reasons =
    useAppSelector((state) =>
      selectOppCloseWinErrorsById(state, opportunityId),
    ) ?? []

  const [{ activeDialog }, dispatch] = useCWQDialogContext()

  const open = activeDialog === 'closeWinError'

  const onClose = useCallback(() => dispatch(closeDialog()), [dispatch])

  const salesFunnel = useAppSelector((state) =>
    selectSalesFunnelById(state, salesFunnelId),
  )

  const salesFunnelName = salesFunnel ? (
    <span>
      sales funnel, <b>{salesFunnel?.name ?? 'selected sales funnel'}</b>,
    </span>
  ) : (
    <span>selected sales funnel</span>
  )
  const styles = getStyles(useTheme())
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={styles.title}>Closing Requirements Missing</DialogTitle>
      <DialogContent>
        <Box sx={styles.message}>
          The {salesFunnelName} has the following requirements to Close/Win this
          Opportunity.
        </Box>
        {reasons && reasons.length > 0 && (
          <Stack>
            {reasons.map((reason, index) => (
              <MissingRequirementDetails key={index} reason={reason} />
            ))}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={onClose}
          data-test-id="close-won-error-dialog-close-button"
        >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  )
}
